import React from "react";

import "./NoSearchResults.scss";

function handleButtonClick(e) {
  e.preventDefault();
  window.location.href = e.target.value;
};

export const NoSearchResults = props => (
  <section className="no-search-results">
    {props.content.textAboveImage && (
      <p dangerouslySetInnerHTML={{__html: props.content.textAboveImage}} />
    )}
    {props.content.image && (
      <img src={props.content.image.src} alt={props.content.image.alt}/>
    )}
    <div>
      {props.content.buttonTextLeft && props.content.buttonLinkLeft && (
        <button className="no-search-results__buttons__left" value={props.content.buttonLinkLeft.url} onClick={handleButtonClick}>{props.content.buttonTextLeft}</button>
      )}
      {props.content.buttonTextRight && props.content.buttonLinkRight && (
        <button className="no-search-results__buttons__right" value={props.content.buttonLinkRight.url} onClick={handleButtonClick}>{props.content.buttonTextRight}</button>
      )}
    </div>
    {props.content.textBelowButtons && (
      <p dangerouslySetInnerHTML={{__html: props.content.textBelowButtons}} />
    )}
  </section>
);